import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import GeneralBetsList from '../../components/GeneralBetsList';
import { getGeneralBetsBettable } from '../../api/generalApi';

const GeneralBets: React.FC = () => {
  const [bettable, setBettable] = useState<boolean>(false);
  const [loadingBettable, setLoadingBettable] = useState<boolean>(true);

  useEffect(() => {
    const fetchBettable = async () => {
      try {
        const data = await getGeneralBetsBettable();
        setBettable(data);
      } catch (err) {
        console.error('Error fetching general bets bettable status:', err);
      } finally {
        setLoadingBettable(false);
      }
    };

    fetchBettable();
  }, []);

  if (loadingBettable) {
    return (
      <Layout>
        <div>
          <h1 className="text-2xl font-bold text-white mb-6">כלליים</h1>
          <div className="mt-4 text-gray-400">טוען נתוני טורניר...</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div >
        <h1 className="text-2xl font-bold text-white mb-6">כלליים</h1>

        {bettable ? (
          <>
            <p className="text-gray-600 mb-6">
              כאן ניתן למלא את כל הכלליים לטורניר.
              {' '}רוצה לסמלץ את הטורניר לפני?{' '}
              <a href="https://cup-predictor.com/createbracket" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">
                לחץ כאן
              </a>
            </p>
            <GeneralBetsList bettable={bettable} />
          </>
        ) : (
          <>
            <p className="text-gray-600 mb-6">
              הטורניר התחיל – ניתן לצפות בכלליים של המשתתפים.
            </p>
            <GeneralBetsList />
          </>
        )}
      </div>
    </Layout>
  );
};

export default GeneralBets;